export default "__VITE_ASSET__92b7ca61__$_?url=__"